import { render, staticRenderFns } from "./ag-badge-wrapper.vue?vue&type=template&id=6108c37e"
import script from "./ag-badge-wrapper.vue?vue&type=script&lang=js"
export * from "./ag-badge-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports